import { useCallback } from "react";
import { type UseFormReturn } from "react-hook-form";
import { useScheduleContext } from "../context/useScheduleContext";
import { useGroups } from "../../../../Settings/General/OrganisationLevelGroups/context";
import { getLevelNames, sectionsToSimpleValues, simpleValuesToSections } from "../../helpers/form/simpleAdvanced";
import type { Resource } from "../../types/Resource";

/** Converts the form between the simple (shift + breaks) and advanced (sections) shapes. */
export const useIsSimpleToggle = (form: UseFormReturn<any>) => {
    const { selectedCellOrEvent } = useScheduleContext();
    const { allocatedGroups } = useGroups();
    const isCreating = selectedCellOrEvent?.isCreating;

    return useCallback((nextIsSimple: boolean) => {
        const values = form.getValues();
        const levelNames = getLevelNames(allocatedGroups);

        if (nextIsSimple) {
            const simpleValues = sectionsToSimpleValues(values, levelNames);
            Object.entries(simpleValues || {}).forEach(([name, value]) => form.setValue(name, value));
            return;
        }

        const sections = simpleValuesToSections(values, {
            levelNames,
            isCreating,
            calcGroupBreaks: (selectedCellOrEvent?.user as Resource)?.calculationGroup?.breaks
        });
        if (sections) {
            form.setValue("sections", sections);
        }
    }, [form, allocatedGroups, isCreating, selectedCellOrEvent?.user]);
};
